<script lang="ts">
  import type { Snippet } from "svelte";

  interface Props {
    centerXHeight?: boolean;
    children?: Snippet;
    size?: "xs" | "sm" | "md";
    class?: string;
  }

  let { centerXHeight = false, children, size = "md", class: className = "" }: Props = $props();
</script>

<span
  class="inline-block rounded-[4px] bg-mono-300 px-1 text-foreground-secondary outline outline-1 outline-border {size ===
  'xs'
    ? 'h-3.5 text-[11px] leading-[14px]'
    : size === 'sm'
      ? 'h-4 text-xs leading-4'
      : 'h-4 text-sm leading-4'} {className}"
>
  <span class={centerXHeight ? "inline-block -translate-y-px" : ""}>
    {@render children?.()}
  </span>
</span>
